export default __webpack_public_path__ + "static/media/onlineUsersActive.a99611de.svg";